import { useEntryPriceAfterSpread } from '@ui/features/Trade/hooks/useEntryPriceAfterSpread';
import { useLiqPriceAfterSpread } from '@ui/features/Trade/hooks/useLiqPriceAfterSpread';
import { useMarketPrice } from '@ui/features/Trade/hooks/useMarketPrice';
import { TpSlValueState } from '@ui/features/Trade/types';
import { OrderType } from '@ui/types/trade';

import { validateStopLossPrice } from '../../../../utils/validateStoppLossPrice';
import { validateTakeProfitPrice } from '../../../../utils/validateTakeProfitPrice';
import {
  useCurrentPairMaxTpRatios,
  useCurrentPairMaxTpRatiosPrice,
} from '../../hooks/useCurrentPairMaxTpRatios';
import { useIsLong } from '../../store/useIsLong';
import { useOrderType } from '../../store/useOrderType';

export const useTakeProfitPriceValidation = (tp: TpSlValueState) => {
  const isLong = useIsLong((s) => s._persistValue);
  const maxTpRatios = useCurrentPairMaxTpRatios();
  const maxTpRatiosPrice = useCurrentPairMaxTpRatiosPrice(); // has max tp limitation
  const marketPrice = useMarketPrice();
  const entryPrice = useEntryPriceAfterSpread();
  const orderType = useOrderType((s) => s._persistValue);
  const isMarket = orderType === OrderType.MARKET;

  return validateTakeProfitPrice({
    isLong,
    entryPrice: entryPrice?.toNumber(),
    tp: tp,
    maxTpRatios,
    maxTpRatiosPrice,
    marketPrice,
    isMarket,
  });
};

export const useStopLossPriceValidation = (sl: TpSlValueState) => {
  const isLong = useIsLong((s) => s._persistValue);

  const entryPrice = useEntryPriceAfterSpread();
  const marketPrice = useMarketPrice();

  const liqPrice = useLiqPriceAfterSpread();

  const orderType = useOrderType((s) => s._persistValue);
  const isMarket = orderType === OrderType.MARKET;

  return validateStopLossPrice({
    isLong,
    entryPrice: entryPrice?.toNumber(),
    sl,
    liqPrice,
    marketPrice,
    isMarket,
  });
};
